const setReducer = (state, action) => action.value;
export default setReducer;
